// 通讯录
const contactsList = [
  {
    contactKey: 'contact',
    name: 'accountName',
    phone: 'accountPhone'
  },
  {
    contactKey: 'ijksfas',
    name: 'qwjnds',
    phone: 'diwhdf'
  },
  {
    contactKey: 'hgdfs',
    name: 'asdew',
    phone: 'vsdgf'
  },
  {
    contactKey: 'wpoojns',
    name: 'dasdw',
    phone: 'qweas'
  },
  {
    contactKey: 'vnfhdvk',
    name: 'qbvhsd',
    phone: 'ohfuei'
  },
  {
    contactKey: 'lnhkj',
    name: 'hcsghi',
    phone: 'qhvfd'
  },
  {
    contactKey: 'onvhj',
    name: 'qjvhsu',
    phone: 'iryui'
  },
  {
    contactKey: 'fsdds',
    name: 'vcew',
    phone: 'sdgff'
  },
  {
    contactKey: 'fbfes',
    name: 'bcsd',
    phone: 'fbbr'
  },
  {
    contactKey: 'dfxc',
    name: 'dfgd',
    phone: 'swee'
  },
  {
    contactKey: 'dgdfes',
    name: 'sdfx',
    phone: 'sweg'
  },
  {
    contactKey: 'ersdf',
    name: 'wewd',
    phone: 'wewr'
  },
  {
    contactKey: 'ewwdfsd',
    name: 'sdfs',
    phone: 'dswe'
  },
  {
    contactKey: 'khruei',
    name: 'cjfheuw',
    phone: 'shjfy'
  },
  {
    contactKey: 'rewrwer',
    name: 'gdfge',
    phone: 'grtrt'
  },
  {
    contactKey: 'qwqease',
    name: 'ewsd',
    phone: 'qweqff'
  },
  {
    contactKey: 'sweerfss',
    name: 'fsdwe',
    phone: 'sdfwsew'
  },
  {
    contactKey: 'wersdfsdf',
    name: 'fdsfws',
    phone: 'dferer'
  },
  {
    contactKey: 'asdjhfd',
    name: 'sdfwe',
    phone: 'vfdsd'
  },
  {
    contactKey: 'ljkhgf',
    name: 'uhgds',
    phone: 'fbtyh'
  },
  {
    contactKey: 'ajhsf',
    name: 'iwhufis',
    phone: 'mbfgey'
  },
  {
    contactKey: 'sfgthykg',
    name: 'fdsj',
    phone: 'fhjty'
  },
  {
    contactKey: 'ioiuyt',
    name: 'mngfe',
    phone: 'rferfsd'
  },
  {
    contactKey: 'dfgerw',
    name: 'gjtr',
    phone: 'retes'
  },
  {
    contactKey: 'kiuyifg',
    name: 'sfwefsd',
    phone: 'hgjtyh'
  },
  {
    contactKey: 'lshjkf',
    name: 'fjahgd',
    phone: 'cbhduw'
  },
  {
    contactKey: 'rwersdfs',
    name: 'fwesd',
    phone: 'vcdf'
  },
  {
    contactKey: 'irwejjje',
    name: 'grwwer',
    phone: 'ffgwe'
  },
  {
    contactKey: 'luwhff',
    name: 'pqhvdis',
    phone: 'bfuehwu'
  },
  {
    contactKey: 'mheuwa',
    name: 'rosnjhds',
    phone: 'pqjhvduis'
  },
  {
    contactKey: 'lkujyhgf',
    name: 'srwefds',
    phone: 'xfvsrtwe'
  },
  {
    contactKey: 'grthyt',
    name: 'dfwe',
    phone: 'sdfsdger'
  },
  {
    contactKey: 'ldhjew',
    name: 'klwbchdw',
    phone: 'ubcjdsvs'
  },
  {
    contactKey: 'pfbkqt',
    name: 'gnuzfe',
    phone: 'pbuehdii'
  },
  {
    contactKey: 'ktwsbpns',
    name: 'heacifnnqm',
    phone: 'wqfxflsq'
  },
  {
    contactKey: 'kygpnqd',
    name: 'rbbfky',
    phone: 'czcithd'
  },
  {
    contactKey: 'tbaoufa',
    name: 'aufbe',
    phone: 'yifwi'
  },
  {
    contactKey: 'ipenndmzcodv',
    name: 'qjfmqqa',
    phone: 'dgchotyur'
  },
  {
    contactKey: 'loemd',
    name: 'uwybckjsd',
    phone: 'puwjbcjks'
  }

]
// 好评弹框方法
const scoreFuncNameList = [
  'uhsdfsa',
  'ffqwr',
  'owjduioe',
  'kvhfdkj',
  'ieuwhyi',
  'oijskdx',
  'hfrrc',
  'dfvsw',
  'ghdc',
  'wefd',
  'aqqww',
  'nvnhjr',
  'sdewew',
  'dfowq',
  'dfwers',
  'sdfwes',
  'sdwfgg',
  'jghg',
  'rinsj',
  'olukgyh',
  'fhntyyt',
  'sdwera',
  'fghewes',
  'ebvhdjs',
  'erwer',
  'werfsz',
  'woenvs',
  'vhduewi',
  'ftyertef',
  'etrwertre',
  'wjbckjdww',
  'srrghrfk',
  'vvgxrfgoq',
  'vxdby',
  'mbuhjfxogu',
  'stcqfzw',
  'ajcbhdjs'
]
export { contactsList, scoreFuncNameList }
